// extracted by mini-css-extract-plugin
export var animationContainer = "_jb-0";
export var asteriskIcon = "_jb-8";
export var conversationLeftSection = "_jb-4";
export var conversationListItem = "_jb-3";
export var conversationMiddleSection = "_jb-5";
export var conversationRightSection = "_jb-6";
export var detailsContent = "_jb-1";
export var listContainer = "_jb-7";
export var modalContent = "_jb-2";